<template>
    <div class="d-flex justify-content-around">
        <!-- Avaliações -->
        <div class="card" style="width: 25rem;">
            <div class="card-body">
                <h5 class="card-title text-center text-primary">Avaliações</h5>
                <div>
                    <div class="d-flex justify-content-center" v-if="avaliacoesCarregando">
                        <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                        </component>
                    </div>
                    <div v-else>
                        <div v-if="avaliacoes.length > 0">
                            <ul class="list-group list-group-flush" v-for="(avaliacao, index) in avaliacoes" :key="index">
                                <li class="list-group-item">
                                    {{ avaliacao.avaliacao_info.descricao }}
                                </li>
                            </ul>
                        </div>
                        <div v-else>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item">Sem Avaliações.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Fim Avaliações -->
        <!-- Infrações -->
        <div class="card" style="width: 25rem;">
            <div class="card-body">
                <h5 class="card-title text-center text-primary">Infrações</h5>
                <div>
                    <div class="d-flex justify-content-center" v-if="avaliacoesCarregando">
                        <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                        </component>
                    </div>
                    <div v-else>
                        <div v-if="infracoes.length > 0">
                            <ul class="list-group list-group-flush" v-for="(infracao, index) in infracoes" :key="index">
                                <li class="list-group-item text-danger">
                                    {{ infracao.infracao.detalhe }}
                                </li>
                            </ul>
                        </div>
                        <div v-else>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item text-success">Sem infrações.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Fim Infrações -->
        <!-- Comportamentos -->
        <div class="card" style="width: 25rem;">
            <div class="card-body">
                <h5 class="card-title text-center text-primary">Comportamentos</h5>
                <div>
                    <div class="d-flex justify-content-center" v-if="avaliacoesCarregando">
                        <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                        </component>
                    </div>
                    <div v-else>
                        <div v-if="comportamentos.length > 0">
                            <ul class="list-group list-group-flush" v-for="(comportamento, index) in comportamentos"
                                :key="index">
                                <li class="list-group-item text-danger">
                                    {{ comportamento.comportamento_info.descricao }}
                                </li>
                            </ul>
                        </div>
                        <div v-else>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item">Sem comportamentos.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Fim Comportamentos -->
    </div>
</template>

<script>
import AgendamentoController from './AgendamentoController'
import * as spinners from 'epic-spinners'

export default {
  name: 'AvaliacoesTab',
  components: {
    ...spinners
  },
  data () {
    return {
      avaliacoesCarregando: false,
      avaliacoes: [],
      infracoes: [],
      comportamentos: []
    }
  },
  props: {
    aulaId: Number
  },
  methods: {
    loadData () {
      this.loadAvaliacao(this.aulaId)
    },

    loadAvaliacao (aula) {
      this.avaliacoesCarregando = true

      AgendamentoController.loadAvaliacoes(aula, response => {
        if (response.sucesso === true) {
          this.avaliacoes = response.dados.avaliacoes
          this.infracoes = response.dados.infracoes
          this.comportamentos = response.dados.comportamentos

          this.avaliacoesCarregando = false
        } else {
          this.avaliacoesCarregando = false
        }
      })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>
